import React from 'react';

import CustomToaster from '@components/CustomToaster';
import SubscriptionForm from '@components/SubscriptionForm';
import { SelectedOffer } from '@utils/backend-api/subscribe';

import PlanOptions from './PlanOptions';

interface ReferralSubscription {
  referralOffer: SelectedOffer;
  referringSubName: string;
  referringSubGuid: string;
  userFullName?: string;
  userEmail?: string;
  stripeCustomerId?: string;
}

const Subscription = ({
  referralOffer,
  referringSubName,
  referringSubGuid,
  userFullName,
  userEmail,
  stripeCustomerId,
}: ReferralSubscription) => {
  return (
    <div className="-mt-20">
      <CustomToaster />
      <PlanOptions referralOffer={referralOffer} referringSubName={referringSubName} />
      <div className="mx-auto w-full px-12 sm:w-8/12 lg:w-6/12">
        <SubscriptionForm
          formLocation="referral_subscribe"
          buttonText="Subscribe"
          selectedOffer={referralOffer}
          presentedOfferCodes={[referralOffer.code]}
          referringSubscriberGuid={referringSubGuid}
          referringSubscriberName={referringSubName}
          userFullName={userFullName}
          userEmail={userEmail}
          stripeCustomerId={stripeCustomerId}
        />
      </div>
    </div>
  );
};

export default Subscription;
